require('./bootstrap');
import * as bootstrap from 'bootstrap';

Main = {
    // Variables.
    baseUrl: window.location.origin,

    /**
     * Initialization.
     *
     */
    init: function () {
        this.ajaxSetup();
        this.validationConfig();
        this.addValidationRules();
        this.logout();
        this.sidebar();
        this.tooltip();

        console.log('Logs: Main script init.');
    },

    tooltip: function () {
        document.addEventListener('DOMContentLoaded', function () {
            var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
            var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new bootstrap.Tooltip(tooltipTriggerEl);
            });
        });
    },

    /**
     * Configure global ajax.
     *
     */
    ajaxSetup: function () {
        $.ajaxSetup({
            headers: {
                'Accept': 'application/json',
                'Authorization': Cookies.get('token') ? 'Bearer ' + Cookies.get('token') : '',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            }
        });
    },

    /**
     * Configure global jquery validation.
     *
     */
    validationConfig: function () {
        $.validator.setDefaults({
            errorElement: 'span',
            errorClass: 'is-invalid',
            errorPlacement: function(error, element) {
                if(element.parent('.input-group').length) {
                    error.insertAfter(element.parent());
                } else {
                    error.insertAfter(element);
                }

                $('html, body').animate({
                    scrollTop: error.offset().top - 300
                }, 50);
            },
            invalidHandler: function(event, validator) {
                var errors = validator.numberOfInvalids();
                if (errors) {
                    if ($(".is-invalid").length) {
                        $('html, body').animate({
                            scrollTop: ($(".is-invalid").first().offset().top - 300)
                        },50);
                    }
                }
            }
        });
    },

    /**
     * Create custom validation rules.
     *
     */
    addValidationRules: function () {
        $.validator.addMethod('phone', function(phone_number, element) {
            phone_number = phone_number.replace(/\s+/g, "");
            return this.optional(element) || phone_number.length > 9 &&
                phone_number.match(/^(\+?1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/);
        }, "Please specify a valid phone number");
    },

    /**
     * Logout in system.
     *
     */
    logout: function (){
        const that = this;

        $(document).ready(function() {
            $(document).on('click', '.js-btn-logout', function (e){
                e.preventDefault();
                $.ajax({
                    type: 'DELETE',
                    url: that.baseUrl + '/api/v1/logout',
                    success:function(data) {
                        Cookies.remove('token');
                        Cookies.remove('users_role_token');
                        Cookies.remove('icdr_session');
                        window.location.replace('/');
                    },
                    error: function (error) {
                        console.error('Logout error:', error);
                    },
                });
            });
        });
    },

    /**
     * Sidebar menu.
     *
     */
    sidebar: function (){
        var that = this;
        $(document).ready(function() {
            const btnSidebarCollapse = $('.js-btn-sidebar-collapse');
            // that.toggleSidebar()
            btnSidebarCollapse.on('click', function () {
                $('#sidebar').toggleClass('active');
                // that.toggleSidebar()
            });
        });
    },
    toggleSidebar: function () {
        if($(window).width() < 1200){
            // if($('#sidebar').hasClass('active')) {
            //     $('.js-sidebar-action-header').hide();
            //     $('.js-sidebar-action-reverse-header').show();
            // } else {
            //     $('.js-sidebar-action-header').show();
            //     $('.js-sidebar-action-reverse-header').hide();
            // }
        } else {
            if($('#sidebar').hasClass('active')) {
                $('.js-sidebar-action-header').show();
                $('.js-sidebar-action-reverse-header').hide();
            } else {
                $('.js-sidebar-action-header').hide();
                $('.js-sidebar-action-reverse-header').show();
            }
        }
    }
};

// Start Initialization.
Main.init();
